/* eslint-disable react/no-array-index-key */
/* eslint-disable space-before-function-paren */
import React, { useState, useRef } from "react";
import Image from "react-bootstrap/Image";
import Nav from "react-bootstrap/Nav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { faStreetView } from "@fortawesome/pro-solid-svg-icons";
import ILG_LOGO from "../../images/auros-design-logo-and-text.svg";
import FLOOR_PLAN from "../../images/floor-plan.svg";
import HOME_ICON from "../../images/home-icon.svg";
import SHARE_ICON from "../../images/share.svg";
import LINK_ICON from "../../images/link.svg";
import MAIL_ICON from "../../images/mail.svg";
import ExploreDesign from "../../images/compare.svg";
import WHATSAPP_ICON from "../../images/whatsapp.svg";
import PlanDetails from "./PlanDetails.js";
import ExploreDesigns from "./ExploreDesigns.js";
import toast from "react-hot-toast";
import FloorPlan from "./FloorPlan.js";

const Header = ({
  loaded,
  selectedDesignId,
  selectedFloor,
  selectedRoom,
  selectedRoomName,
  floorList,
  scenes,
  scene,
  inProgressImage,
  openMenu,
  thumbnailMap,
  setScene,
  onRoomSelect,
  setOpenMenu,
  onDesignSelect,
  handleFloorSelection,
  getRoomInfo,
  setSelectedFloor,
  getImageScene,
  handleLoading,
  grid,
  fullScreen,
  plan,
  nameMap,
  floorPlans,
}) => {
  const [openMap, setOpenMap] = useState(false);

  const handleDesignSelect = (design) => {
    onDesignSelect(design);
  };

  const roomSet = new Set();
  const scroller = useRef();

  const setScrollBar = (diff) => {
    scroller.current.scrollBy(diff, 0);
  };

  const sharetoWhatsapp = () => {
    window.open(`https://web.whatsapp.com/send?text=${encodeURIComponent(window.location.href)}`);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(window.location.href);
    toast.success("Copied");
  };

  const emailLink = () => {
    window.location.href = `mailto:?&subject=Web tour for Floor: ${grid.grid}&body=Hi,%0D%0A%0D%0APlease find link for Floor: ${grid.grid}%0D%0A%0D%0A${window.location.href}%0D%0A`;
  };

  const getSelectedFloorImage = () => {
    if (!floorPlans || !floorPlans.length) {
      return "";
    }
    const floor = floorPlans.find(
      (f) => f.name?.toLowerCase() === selectedFloor?.toLowerCase()
    );
    if (floor) {
      return floor.imageUrl;
    }
    return "";
  };

  return (
    <Nav
      className="justify-content-between header-v2 new-header-wrapper-left"
      variant="none"
      style={{
        visibility: fullScreen ? "hidden" : "visible",
      }}
    >
      <Nav.Item className="header-design-myhome-wrapper" title="Home">
        <Image
          className={`header-logo`}
          src={ILG_LOGO}
          style={{ visibility: "visible" }}
        />
        <span className="separator"></span>
        {grid && grid.communityName && (
          <span className="header-btn info-btn">
            <img src={HOME_ICON} alt="Home Icon" /> {grid.communityName}{" "}
            {plan?.floorplanName ? " | " + plan?.floorplanName : ""}
          </span>
        )}
      </Nav.Item>
      <Nav.Item
        className="new-header-wrapper-right header-design-myhome-wrapper"
        data-tour="observable-parent"
      >
        <div
          style={{
            position: "relative",
          }}
        >
          <span
            onClick={() => {
              setOpenMenu(openMenu === "floors" ? "" : "floors");
            }}
            className="header-btn dd-btn"
            data-tour="reactour__floor"
            style={{
              display: !loaded || !!floorList.length ? "flex" : "none",
            }}
          >
            {selectedFloor !== null ? selectedFloor : "Floors"}
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="chevron-down"
              className="svg-inline--fa fa-chevron-down fa-w-14 "
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              width={"12px"}
            >
              <path
                fill="currentColor"
                d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
              ></path>
            </svg>
          </span>
          <div
            style={{
              display: openMenu === "floors" ? "flex" : "none",
            }}
            className="dd-container"
          >
            {floorList.map((floor) => {
              return (
                <div
                  key={floor.floorName}
                  className="dd-item"
                  onClick={() => {
                    handleFloorSelection(floor);
                  }}
                >
                  {floor.floorName}
                </div>
              );
            })}
          </div>
        </div>
        <div>
          <span
            onClick={() => {
              setOpenMenu(openMenu === "rooms" ? "" : "rooms");
            }}
            className="header-btn dd-btn"
            data-tour="reactour__room"
          >
            {selectedRoomName || "Rooms"}
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="chevron-down"
              className="svg-inline--fa fa-chevron-down fa-w-14 "
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              width={"12px"}
            >
              <path
                fill="currentColor"
                d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
              ></path>
            </svg>
          </span>
          <div
            style={{
              maxWidth: "calc(100vw - 48px)",
              width: "auto",
              display: openMenu === "rooms" ? "flex" : "none",
              padding: "10px 0",
              marginTop: "20px",
              overflow: "hidden",
              height: "104px",
              backgroundColor: "rgba(255,255,255,0.5)",
              flexDirection: "row",
              border: "none",
            }}
            className="dd-container right"
          >
            <div
              style={{
                padding: "5px",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => setScrollBar(-160)}
            >
              <svg
                style={{ width: "24px" }}
                focusable="false"
                aria-hidden="true"
                viewBox="0 0 24 24"
              >
                <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
              </svg>
            </div>
            <div
              ref={scroller}
              style={{
                flexGrow: 1,
                display: "flex",
                gap: "10px",
                overflow: "auto",
                scrollSnapType: "x proximity",
                scrollBehavior: "smooth",
                marginBottom: "-30px",
                paddingBottom: "15px",
                height: "120px",
              }}
            >
              {Object.keys(scenes).map((sceneKey) => {
                const sceneObj = scenes[sceneKey];
                const key = sceneObj.renderKey;

                if (!key || !sceneObj) {
                  return "";
                }

                const roomInfo = getRoomInfo(key);
                const isSelected = scene?.renderKey === key;
                if (
                  floorList?.length &&
                  roomInfo?.room?.floorName &&
                  roomInfo?.room?.floorName?.toLowerCase() !==
                    selectedFloor?.toLowerCase()
                ) {
                  return "";
                }
                if (roomInfo?.room.name && roomSet.has(roomInfo.room.name)) {
                  return "";
                }
                roomSet.add(roomInfo.room.name);
                return (
                  <div
                    key={sceneKey}
                    style={{
                      flex: "none",
                      scrollSnapAlign: "start",
                      textAlign: "left",
                      color: "black",
                      cursor: "pointer",
                      borderRadius: "5px",
                      overflow: "hidden",
                      position: "relative",
                      minWidth: "160px",
                      width: "160px",
                      fontSize: 0,
                      height: "104px",
                    }}
                    onClick={() => {
                      roomInfo.room.floorName &&
                        setSelectedFloor(roomInfo.room.floorName);
                      const scene = getImageScene(roomInfo.cameraNumber);
                      setOpenMenu("");
                      if (!scene?.image || inProgressImage) {
                        handleLoading(scene);
                        return;
                      }
                      setScene(scene);
                    }}
                  >
                    {thumbnailMap[key] ? (
                      <img
                        style={{
                          width: "160px",
                          height: "104px",
                          objectFit: "cover",
                        }}
                        src={thumbnailMap[key]}
                        alt="Preview"
                      />
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "160px",
                          height: "104px",
                        }}
                        className="skeleton-box"
                      ></div>
                    )}
                    {isSelected && (
                      <FontAwesomeIcon
                        className="street-icon"
                        icon={faStreetView}
                        style={{
                          position: "absolute",
                          left: "50%",
                          top: "50%",
                          marginLeft: "-14px",
                          marginTop: "-14px",
                          width: "18px",
                          height: "18px",
                        }}
                      />
                    )}
                    <span
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        background:
                          "linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.5) 75%, rgba(0, 0, 0, 0) 100%)",
                        padding: "10px 10px 5px",
                        color: "white",
                        width: "100%",
                        boxSizing: "border-box",
                        fontSize: "14px",
                      }}
                    >
                      {roomInfo?.room.displayName || roomInfo?.room.name}
                    </span>
                  </div>
                );
              })}
            </div>
            <div
              style={{
                padding: "5px",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => setScrollBar(160)}
            >
              <svg
                style={{ width: "24px" }}
                focusable="false"
                aria-hidden="true"
                viewBox="0 0 24 24"
              >
                <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
              </svg>
            </div>
          </div>
        </div>
        <span className="separator"></span>
        {grid?.linkedWebTours?.length > 1 && (
          <div
            className="explore-options-new cursor-pointer custom-dropdown-title header-btn"
            data-tour="reactour__explore"
            style={{
              zIndex: "99",
              fontSize: "14px",
              gap: "10px",
            }}
            onClick={() => {
              setOpenMenu(openMenu === "compare" ? "" : "compare");
              setOpenMap(false);
            }}
          >
            <img src={ExploreDesign} alt="Explore Designs" /> Explore Designs
          </div>
        )}
        <div
          className="floorplan-options-new cursor-pointer custom-dropdown-title header-btn"
          data-tour="reactour__plan"
          style={{
            zIndex: "99",
            fontSize: "14px",
            gap: "10px",
          }}
          onClick={() => {
            if (getSelectedFloorImage()) {
              setOpenMap(!openMap);
              setOpenMenu("");
            } else {
              setOpenMenu(openMenu === "plan" ? "" : "plan");
            }
          }}
        >
          <img src={FLOOR_PLAN} alt="floorMap" /> Floor Plan
          {!getSelectedFloorImage() && (
            <div
              style={{
                display: openMenu === "plan" ? "flex" : "none",
              }}
              className="dd-container right"
            >
              <PlanDetails grid={grid} plan={plan} vertical={true} />
            </div>
          )}
        </div>
        <div
          style={{
            marginRight: "5px",
            position: "relative",
          }}
        >
          <span
            onClick={() => {
              setOpenMenu(openMenu === "share" ? "" : "share");
            }}
            className="header-btn"
          >
            <img src={SHARE_ICON} alt="Share Icon" />
          </span>
          <div
            style={{
              display: openMenu === "share" ? "flex" : "none",
            }}
            className="dd-container right"
          >
            <div
              className="dd-item"
              onClick={() => {
                copyToClipboard();
                setOpenMenu("");
              }}
            >
              <img
                src={LINK_ICON}
                alt="icon"
                style={{ verticalAlign: "middle", marginRight: "4px" }}
              />
              &nbsp; Copy to Clipboard
            </div>
            <div
              className="dd-item"
              onClick={() => {
                emailLink();
                setOpenMenu("");
              }}
            >
              <img
                src={MAIL_ICON}
                alt="icon"
                style={{ verticalAlign: "middle", marginRight: "4px" }}
              />
              &nbsp; Email
            </div>
            <div
              className="dd-item"
              onClick={() => {
                sharetoWhatsapp();
                setOpenMenu("");
              }}
            >
              <img
                src={WHATSAPP_ICON}
                alt="icon"
                style={{ verticalAlign: "middle", marginRight: "4px" }}
              />
              &nbsp; WhatsApp
            </div>
          </div>
        </div>
        {getSelectedFloorImage() && openMap && (
          <ClickAwayListener onClickAway={() => setOpenMap(false)}>
            <FloorPlan
              selectedRoom={selectedRoom}
              selectedFloor={selectedFloor}
              grid={grid}
              plan={plan}
              floorPlans={floorPlans}
              openMap={openMap}
              setOpenMap={setOpenMap}
              onRoomSelect={onRoomSelect}
              nameMap={nameMap}
            />
          </ClickAwayListener>
        )}
        {grid?.linkedWebTours?.length > 1 && openMenu === "compare" && (
          <ExploreDesigns
            grid={grid}
            selectedDesignId={selectedDesignId}
            setOpenMenu={setOpenMenu}
            onDesignSelect={handleDesignSelect}
          />
        )}
      </Nav.Item>
    </Nav>
  );
};

export default Header;
